import { SVGProps } from 'react';

const Venus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 15v7m0-7a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-3 4h6"
    />
  </svg>
);
export default Venus;
